// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"CallVideo_videoContainer__fpqgS","video":"CallVideo_video__ZREvF","ieVideo":"CallVideo_ieVideo__3I8xM","spin360":"CallVideo_spin360__2BIpP"};